/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FirmwareByDeviceTypeResponse,
    FirmwareByDeviceTypeResponseFromJSON,
    FirmwareByDeviceTypeResponseFromJSONTyped,
    FirmwareByDeviceTypeResponseToJSON,
} from './FirmwareByDeviceTypeResponse';

/**
 * 
 * @export
 * @interface FirmwaresByDeviceTypeResponse
 */
export interface FirmwaresByDeviceTypeResponse {
    /**
     * 
     * @type {Array<FirmwareByDeviceTypeResponse>}
     * @memberof FirmwaresByDeviceTypeResponse
     */
    firmwares?: Array<FirmwareByDeviceTypeResponse>;
    /**
     * 
     * @type {number}
     * @memberof FirmwaresByDeviceTypeResponse
     */
    count?: number;
}

export function FirmwaresByDeviceTypeResponseFromJSON(json: any): FirmwaresByDeviceTypeResponse {
    return FirmwaresByDeviceTypeResponseFromJSONTyped(json, false);
}

export function FirmwaresByDeviceTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FirmwaresByDeviceTypeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'firmwares': !exists(json, 'firmwares') ? undefined : ((json['firmwares'] as Array<any>).map(FirmwareByDeviceTypeResponseFromJSON)),
        'count': !exists(json, 'count') ? undefined : json['count'],
    };
}

export function FirmwaresByDeviceTypeResponseToJSON(value?: FirmwaresByDeviceTypeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'firmwares': value.firmwares === undefined ? undefined : ((value.firmwares as Array<any>).map(FirmwareByDeviceTypeResponseToJSON)),
        'count': value.count,
    };
}

